module.exports = __webpack_public_path__ + "img/PayPal2.732495f3.png";